function IntersectionOb(minTop, maxBottom) {
    let ElArr = [], elMap = new Map();
    let o = null;
    this.minTop = minTop;
    this.maxBottom = maxBottom;
    this.addEventEls = [];

    //开始侦听
    this.listenerScroll = function (el, showfn) {
        if (o == null) {
            o = new IntersectionObserver(_ob, {
                rootMargin: minTop + "px 0px " + maxBottom + "px"
            });
        }
        elMap.set(el, showfn);
        o.observe(el);
    }
    function _ob(entries) {
        for (let entry of entries) {
            if (entry.intersectionRatio > 0) {
                console.log(entry, "出现在屏幕内");
                let showFn = elMap.get(entry.target);
                showFn && showFn();
                elMap.delete(entry.target);
                o.unobserve(entry.target);
                if (elMap.size == 0) {
                    o.disconnect();
                    o = null;
                }
            }
        }
    }
}
module.exports = IntersectionOb;